import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { HarvestsService } from 'src/app/Services/agricola/harvest.service';
import { GlobalFunction } from 'src/app/Services/public/globalFunction';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-harvest-modal',
  templateUrl: './harvest.component.html',
  styleUrls: ['./harvest.component.scss'],
})
export class HarvestComponent implements OnInit {
  @Output('event') event = new EventEmitter();
  @Input('cycle') cycle;
  form: FormGroup;

  constructor(
    public harvestsService: HarvestsService,
    public globalFunction: GlobalFunction,
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      date: ['', Validators.required],
      kg: ['', [Validators.required, Validators.min(1)]],
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    if (this.form.valid) {
      let obj = {
        cycle: this.cycle.id,
       ...this.form.value,
      }
      this.harvestsService.createHarvest(obj).subscribe((res) => {
        console.log('Harvest creado:', res);
        this.event.emit('success');
        this.globalFunction.Modal(``, `hide`, {});
      });
    }
  }
}
